import { putMethod } from "./api-service";

/**
 * Update specifications for a specific colorway
 * PUT /api/products/:productId/colorways/:colorwayId/specifications
 */
export const updateColorwaySpecifications = async (productId, colorwayId, specifications) => {
    try {
        const response = await putMethod(
            `/products/${productId}/colorways/${colorwayId}/specifications`,
            specifications
        );
        return response;
    } catch (error) {
        console.error('Error updating colorway specifications:', error);
        return { success: false, message: error.response?.data?.message || error.message };
    }
};



/**
 * Update common components
 * PUT /api/products/:productId/common-components
 */
export const updateCommonComponents = async (productId, commonComponents) => {
    try {
        const response = await putMethod(
            `/products/${productId}/common-components`,
            { commonComponents }
        );
        return response;
    } catch (error) {
        console.error('Error updating common components:', error);
        return { success: false, message: error.response?.data?.message || error.message };
    }
};

export const updateCategoryDisplayColumns = async (categoryId, data) => {
    try {
        const response = await putMethod(`/raw-material-category/${categoryId}/display-columns`, data);
        return response;
    } catch (error) {
        console.error("Error updating display columns:", error);
        return null;
    }
};